import {
    post,
    get,
    put,
    del,
    postForm,
    postFile,
    pkceUtils
  } from '../utils/http'

const api = {
    // @deprecated 该函数已废弃，现在通过SSO直接登录，不再需要密码登录
    // 保留此函数仅用于向后兼容或备用场景
    login:(data)=>{
        // 检查是否有SSO access_token
        const ssoToken = localStorage.getItem('sso_access_token');

        // 定义请求头
        const headers = {};
        if (ssoToken) {
            // 如果有SSO token，添加到请求头
            headers['X-SSO-Token'] = ssoToken;
            //console.log('使用SSO Token登录:', ssoToken);
        }

        //console.log('登录请求参数:', data);
        //console.log('登录请求头:', headers);

        // 使用自定义请求头发送请求
        return postForm('/api/v1/auth/login', data, headers)
            .then(response => {
                //console.log('登录响应:', response);
                return response;
            })
            .catch(error => {
                console.error('登录请求失败:', error);
                throw error;
            });
    },
    // SSO认证获取令牌
    getSSOToken:(code)=>{
        // 获取之前存储的code_verifier
        const codeVerifier = pkceUtils.getCodeVerifier();
        //console.log('获取SSO Token，使用code_verifier:', codeVerifier);

        // 使用简化的请求方式 - 使用查询参数
        return get('/api/v1/sso/token', {
            code: code,
            code_verifier: codeVerifier
        });
    },
    // 获取SSO配置
    getSSOConfig:()=>{
        return get('/api/v1/sso/config')
    },
    // 获取所有产品
    getAllProduct:()=>{
        return get('/api/v1/product/all')
    },
    // 获取产品
    getProduct:(data)=>{
        return get(`/api/v1/product/`,data)
    },
    // 新增产品
    addProduct:(data)=>{
        return post('/api/v1/product/',data)
    },
    // 更新产品
    updateProduct:(data)=>{
        return put(`/api/v1/product/${data.id}`,data)
    },
    // 删除产品
    delProduct:(data)=>{
        return del(`/api/v1/product/${data.id}`)
    },
    // 获取物料
    getMate:(data)=>{
        return get(`/api/v1/material/`,data)
    },
    // 新增物料
    addMate:(data)=>{
        return post(`/api/v1/material/`,data)
    },
    // 更新物料
    updateMate:(data)=>{
        return post(`/api/v1/material/${data.id}`,data)
    },
    // 删除物料
    delMate:(data)=>{
        return del(`/api/v1/material/${data.id}`)
    },
    // 上传文件
    uploadFile:(data)=>{
        return postFile(`/api/v1/upload/`,data)
    },
    // 获取用户信息
    getUserInfo:(url)=>{
        return get(url)
    },
    // 获取产品识别日志
    getProductRecognitionLogs:(productId)=>{
        return get(`/api/v1/product/recognition/logs?product_id=${productId}`)
    },
    // ===== 店铺管理 =====
    // 批量导入店铺（覆盖式：已存在的连锁+店铺仅更新地址，store_code 不变）
    importStores:(data)=>{
        return post('/api/v1/store/import', data)
    },
    // 店铺分页列表
    getStores:(data)=>{
        return get('/api/v1/store/', data)
    },
    // 全量店铺列表（批量生成二维码用）
    getAllStores:()=>{
        return get('/api/v1/store/all')
    },
    // 更新店铺
    updateStore:(data)=>{
        return put(`/api/v1/store/${data.id}`, data)
    },
    // 删除店铺
    delStore:(data)=>{
        return del(`/api/v1/store/${data.id}`)
    },
    // 行为日志（可按店铺/产品过滤）
    getRecognitionLogs:(params)=>{
        return get('/api/v1/product/recognition/logs', params)
    }
}

export default api



// WEBPACK FOOTER //
// ./src/api/index.js